import { Modal } from "react-bootstrap";
import "./BillStatement.style.scss";
// import { checkProduct } from "src/utils/storage/product";
import awardIcon from "src/assets/images/award.svg";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { useRef, useMemo } from "react";
import { useReactToPrint } from "react-to-print";
import { useGetBillHistory } from "src/hooks/api/pay/useGetBillHistory";
import { useTranslation } from "react-i18next";
import { formatDate, getSubscriptionTypeText } from "src/utils/pay/billUtils";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";

interface IBillStatementModalProps {
  showBillStatement: boolean;
  cancelButton: () => void;
}
const BillStatementModal = ({
  showBillStatement,
  cancelButton,
}: IBillStatementModalProps) => {
  const { t } = useTranslation();
  // const checkProductName = checkProduct("WRAPSODY_ECO");
  const checkProductName = getProductFromSessionStorage() === "WRAPSODY_ECO";
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { billHistory } = useGetBillHistory({});
  const { serviceBillHisUid } = useBillStatement();
  // serviceBillHisUid에 해당하는 항목 찾기
  const billHistoryItem = useMemo(() => {
    if (!serviceBillHisUid || !billHistory?.length) {
      return billHistory?.[0] || null;
    }
    return (
      billHistory.find(
        (item: any) => item.serviceBillHisUid === serviceBillHisUid
      ) || billHistory[0]
    );
  }, [serviceBillHisUid, billHistory]);

  const handlePrint = useReactToPrint({
    content: () => modalBodyRef.current,
    documentTitle: "bill print",
    // onAfterPrint:()=>alert('프린트완료')
  });
  const goPrint = () => {
    const app: any = document.getElementById("root");
    const modal: any = document.getElementById("billModal");
    const printContents = document.querySelector(".modal-body")?.innerHTML;
    const printDiv = document.createElement("DIV");

    document.body.appendChild(printDiv);
    printDiv.innerHTML = printContents ?? "";
    app.style.display = "none";
    modal.style.display = "none";

    // window.print();

    app.style.display = "block";
    modal.style.display = "block";
    printDiv.style.display = "none";
    printDiv.innerHTML = "";
  };
  return (
    <Modal
      show={showBillStatement}
      backdrop="static"
      className="billStatementModal"
      id="billModal"
      style={{ opacity: 1 }}
    >
      <Modal.Header>
        <Modal.Title style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3>{t("siteManagement.paymentHistory.history.bill")}</h3>
            <div className="exit">
              <a onClick={cancelButton}>
                <i className="icon_cancel" />
              </a>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body ref={modalBodyRef}>
        <div>
          {/* {isLoading ? <Loading /> : ""} */}
          {billHistoryItem ? (
            <div className="width w-800 text text--13 line-height-180">
              <div className="mg mb-50">
                <figure
                  className={
                    getProductFromSessionStorage() === "WRAPSODY"
                      ? "icon_wrapsody"
                      : "icon_eco"
                  }
                ></figure>
                <p>
                  {t("siteManagement.paymentHistory.bill.address.address_1")}
                </p>
                <p>
                  {t(
                    "siteManagement.paymentHistory.bill.address.detailedAddress"
                  )}
                </p>
                <p>
                  {t("siteManagement.paymentHistory.bill.address.postalCode")}
                </p>
                <p>{t("siteManagement.paymentHistory.bill.address.email")}</p>
              </div>

              <div className="flex justify-space-between align-center mg mb-30">
                <h3 className="text text--20">
                  {t("siteManagement.paymentHistory.bill.detail.title")}
                </h3>
                <button
                  type="button"
                  id="printBtn"
                  className="btn btn-green"
                  onClick={handlePrint}
                >
                  {t("siteManagement.paymentHistory.bill.detail.printBtn")}
                </button>
              </div>

              <table className="table mg mb-30">
                <thead>
                  <tr className="top bottom">
                    <th>
                      <span>
                        {t("siteManagement.paymentHistory.bill.detail.payType")}
                      </span>
                    </th>
                    <th>
                      <span>
                        {t("siteManagement.paymentHistory.bill.detail.user")}
                      </span>
                    </th>
                    <th>
                      <span>
                        {t(
                          "siteManagement.createSite.detail.storage.fieldname"
                        )}
                        (
                        {t("siteManagement.createSite.detail.storage.byteUnit")}
                        )
                      </span>
                    </th>
                    <th>
                      <span>
                        {t(
                          "siteManagement.paymentHistory.bill.detail.paymentDate"
                        )}
                      </span>
                    </th>
                    <th>
                      <span>
                        {t("siteManagement.paymentHistory.history.period")}
                      </span>
                    </th>
                    {billHistoryItem.payCompany === "CASH" && (
                      <th>
                        <span>{t("cashStatus.history")}</span>
                      </th>
                    )}
                    <th>
                      <span>
                        {t("siteManagement.paymentHistory.bill.detail.price")}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="inline-block vertical-middle billMgnt__history billMgnt__historyType  align-center">
                        {/* <i
                          className={`icon_${billHistoryItem.billType}_label`}
                        /> */}
                        {/* <i className={`icon_PAY_label`} /> */}
                        {/* <i className="bi bi-credit-card"></i> */}
                        <div id="billIcon">
                          {/* <LuAward
                            id="billIcon"
                            style={{
                              fontSize: "20px",
                              textAlign: "center",
                              display: "flex",
                              color: "#4c86f4",
                            }}
                          /> */}
                          <img src={awardIcon} alt="" />
                        </div>
                      </div>
                      <div className="inline-block vertical-middle">
                        <span>
                          {t(
                            getSubscriptionTypeText(
                              billHistoryItem,
                              checkProductName
                            )
                          )}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div style={{ paddingTop: "5px" }}>
                        {billHistoryItem.licenseCount}
                      </div>
                    </td>
                    <td>
                      <div style={{ paddingTop: "5px" }}>
                        {`${
                          billHistoryItem.licenseCount *
                          billHistoryItem.userPerStorage
                        }`}
                      </div>
                    </td>
                    <td>
                      <div style={{ paddingTop: "5px" }}>
                        {formatDate(billHistoryItem.payDate)}
                      </div>
                    </td>
                    <td>
                      {billHistoryItem.priceType !== "cancel" ? (
                        <div style={{ paddingTop: "5px" }}>
                          {formatDate(billHistoryItem.subscriptionStartDate)}~
                          {formatDate(billHistoryItem.subscriptionEndDate)}
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                    {billHistoryItem.payCompany === "CASH" && (
                      <td>
                        <div style={{ paddingTop: "5px" }}>
                          {t("cashStatus.complete")}
                        </div>
                      </td>
                    )}
                    <td>
                      <div style={{ paddingTop: "5px" }}>
                        {String(billHistoryItem?.visiblePrice) === "0" ? (
                          t(
                            "siteManagement.paymentHistory.bill.partner.inquiry"
                          )
                        ) : (
                          <NumberFormat
                            num={
                              Number(billHistoryItem?.visiblePrice) > 0
                                ? Number(billHistoryItem?.visiblePrice)
                                : Number(billHistoryItem.totalPrice)
                            }
                            currency={billHistoryItem.currency}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table mg mb-0">
                <tbody>
                  <tr className="top bottom">
                    <td>
                      <b>
                        {t("siteManagement.paymentHistory.bill.detail.total")}
                      </b>
                    </td>
                    <td colSpan={3} className="text-right">
                      <div style={{ paddingTop: "5px" }}>
                        {String(billHistoryItem?.visiblePrice) === "0" ? (
                          // 파트너사 문의
                          t(
                            "siteManagement.paymentHistory.bill.partner.inquiry"
                          )
                        ) : (
                          <NumberFormat
                            num={
                              Number(billHistoryItem?.visiblePrice) > 0
                                ? Number(billHistoryItem?.visiblePrice)
                                : Number(billHistoryItem.totalPrice)
                            }
                            currency={billHistoryItem.currency}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/*<p className="text text--gray text-right">
                  {t(
                    'siteManagement.paymentHistory.bill.detail.info'
                  )}
                </p>*/}
            </div>
          ) : (
            ""
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BillStatementModal;
